const AssistDepartment = ["生产车间", "管理部门", "研发部门", "服务部门", "生产管理", "销售部门", "行政部门","工程部门"];
export default AssistDepartment;